/**
 * 知识管理路由保护组件
 * 只有系统管理员和知识管理员可以访问知识管理栏目
 */
import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { hasKnowledgeManagementAccess } from '../utils/knowledgeLotteryAuth';

const KnowledgeManagementRoute = ({ children }) => {
  const location = useLocation();
  const [hasPermission, setHasPermission] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        // 检查管理权限（create或update），而不是查看权限
        const permission = await hasKnowledgeManagementAccess();
        console.log('KnowledgeManagementRoute: 权限检查结果', permission);
        setHasPermission(permission);
      } catch (error) {
        console.error('KnowledgeManagementRoute: 权限检查失败', error);
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };
    checkPermission();
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!hasPermission) {
    // 没有权限，显示错误提示并重定向到知识抽查首页（只能查看）
    // 延迟一下，让用户看到错误提示
    setTimeout(() => {
      const userStr = localStorage.getItem('user');
      let userInfo = '';
      if (userStr) {
        try {
          const user = JSON.parse(userStr);
          userInfo = `（当前用户: ${user.name || user.email}）`;
        } catch (e) {
          // ignore
        }
      }
      alert(`您没有访问知识管理系统的权限，请联系管理员分配知识管理角色${userInfo}`);
    }, 100);
    return <Navigate to="/knowledge-lottery" replace />;
  }

  return children;
};

export default KnowledgeManagementRoute;
